var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exchange-router"},[_c('router-view',{attrs:{"exchangeDate":_vm.exchangeDate,"exchangeName":_vm.exchangeName,"type":_vm.type,"errorCode":_vm.errorCode,"prizeList":_vm.prizeList},on:{"submitCode":_vm.submitCode,"getList":_vm.getList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }